import { defineComponent as _defineComponent } from 'vue'

import { ScannedContainer } from './DispatchContainers.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScannedContainersList',
  props: {
  scannedContainers: {
    type: Array<ScannedContainer>,
    required: true,
  },
  canRemoveContainer: {
    type: Boolean,
    default: false,
  },
},
  emits: ["removeScannedContainer"],
  setup(__props, { emit }: { emit: ({
  (e: 'removeScannedContainer', id: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





return { __sfc: true,props, emit }
}

})